import cn from "classnames";
import React from "react";

const ButtonField = ({ 
    onClick, 
    showHelp, 
    handleSHow, 
    id, 
    handleCancelClick, 
    isClicked = false, 
    children 
}) => {
    return (
        < >
            <div className="flex flex-row space-x-1" id={id}>
                {showHelp && 
                    <button className="text-pblue text-sm" onClick={handleSHow}> 
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                        </svg>
                    </button>
                }
                <button
                    className={cn(
                        isClicked ? 'bg-yellowgray text-white font-semibold shadow-xl justify-between' : 'justify-center items-center bg-transparent shadow-md text-gray border border-yellowgray hover:text-yellowgray hover:shadow-2xl',
                        "whitespace-wrap w-full text-xs md:text-sm text-center flex flex-row  border rounded-lg p-3 px-5 md:px-6 py-2 uppercase"
                    )}
                    onClick={!isClicked ? onClick : undefined}
                >
                    {children}
                    <svg onClick={handleCancelClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`${!isClicked ? 'hidden' : 'block '}${' w-6 h-6 '}`}>
                        <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </>
    )
}
export default ButtonField;
